export class SchemeModel {
    id: Number;
    scheme_name: String;
    start_date: String;
    end_date: String;
    status: Number;
    config_flag: Number;
}